const lazyLoad = (file) => () =>
  import(/* webpackChunkName: "[request]" */ `@/views/settings/finance/${file}.vue`);

const makeGroupRoutes = (name, featureCode, file) => [
  {
    path: `/${name}`,
    name: name,
    meta: { requiresAuth: true, applicationFeatureCode: featureCode },
    components: { content: lazyLoad(file) },
  },
  {
    path: `/${name}/create`,
    name: `${name}-create`,
    meta: { requiresAuth: true, applicationFeatureCode: featureCode },
    components: { content: lazyLoad(file) },
  },
  {
    path: `/${name}/review/:id`,
    name: `${name}-review`,
    meta: { requiresAuth: true, applicationFeatureCode: featureCode },
    components: { content: lazyLoad(file) },
  },
  {
    path: `/${name}/edit/:id`,
    name: `${name}-edit`,
    meta: { requiresAuth: true, applicationFeatureCode: featureCode },
    components: { content: lazyLoad(file) },
  },
];

export default [
  // GL Auto Post Accounts
  ...makeGroupRoutes("gl-auto-post-accounts", "GLAutoPostAccounts", "gl-auto-post-accounts"),

  // GL Reporting Groups 1–10
  ...Array.from({ length: 10 }, (_, i) => {
    const num = String(i + 1).padStart(2, "0");
    return makeGroupRoutes(
      `gl-reporting-group-${num}`,
      `GLReportingGroup${i + 1}`,
      `gl-reporting-group`
    );
  }).flat(),
];